module.exports = __webpack_public_path__ + "img/menu-hair-8.0c111d38.webp";